var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-chip", { staticClass: "ma-2" }, [
                _vm._v(" Other Costs Presale Subtotals "),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "2" } },
            [
              _c("pga-currency-field", {
                attrs: { label: "Expected Cost", readonly: "" },
                model: {
                  value: _vm.expectedCost,
                  callback: function ($$v) {
                    _vm.expectedCost = $$v
                  },
                  expression: "expectedCost",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }